// rid.js
export function getRid() {
  if (typeof window === "undefined") return null;

  try {
    let rid = localStorage.getItem("rid");

    if (!rid) {
      rid = crypto?.randomUUID
        ? crypto.randomUUID()
        : "rid-" + Date.now() + "-" + Math.random().toString(36).slice(2, 10);

      localStorage.setItem("rid", rid);
    }

    // 取得主網域（例如 bwd8.tw）
    const host = window.location.hostname;
    const parts = host.split(".");
    let rootDomain = host;

    // 例如：play.bwd8.tw → bwd8.tw
    if (parts.length >= 2) {
      rootDomain = "." + parts.slice(-2).join(".");
    }

    // 跨所有子網域 cookie
    document.cookie =
      `rid=${encodeURIComponent(rid)}; ` +
      `path=/; ` +
      `max-age=${60 * 60 * 24 * 365}; ` +
      `domain=${rootDomain}; ` +
      `SameSite=Lax`;

    return rid;
  } catch (e) {
    console.error("RID error:", e);
    return null;
  }
}
